import I18n from "i18n-js"

export const useTranslation = () => {
  return {
    t: I18n.t,
    locale: I18n.locale,
  }
};
